import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'
import { dateFormat } from 'highcharts';
import {createRECManifest} from '../../../services/createRECManifest';
import UserIPTracking from '../../../interface/userTracker';
import {sendIPTrackingData} from '../../../services/userIPTrack';

export default {
  name: 'editActionByFinance',
  components: {

  },
  data() {
    return {
      awbNumbers: [],
      description: '',
      damage_type: '',
      myStr: '',
      username: '',
      dataof:'',
      update_dispose: {}
    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.awbNumbers = this.$route.query.awb;
  },

  methods: {

    Backinvestigation() {
      this.$router.push({ path: '/ActionByFinanceForcefullyLostBulk' });
    },
    selectData(event) {
      this.damage_type = event;
    },

    update() {
      
      if (!this.damage_type) {
        this.$alertify.error("Please Select Damage Type.")
      } else if (!this.description) {
        this.$alertify.error("Please Fill Description.")
      } else {
          console.log("this.damage_type: ", this.damage_type);
          this.update_dispose = {
            ShippingID: this.awbNumbers,
            ShipmentVerifiedAs: this.username,
            ActionStatusId: this.damage_type,
            Comments: this.description,
            LastModifiedBy: this.username
          };

          // if (this.damage_type !== 24) {
          //   this.update_dispose.ActionStatusId = "Forcefully Lost";
          // }
          
        axios({
          method: 'post',
          url: apiUrl.api_url + 'UpdateDisposeAndForcefullyLostFinance',
          data: this.update_dispose,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }

        }).then(result => {

          var alldata = result.data.data2
          alldata.forEach(ele => {
            if (ele.ReturnCode == 100) {
              setTimeout(async () => {
                if (this.damage_type == 24) {
                  this.awbNumbers.forEach(async shippingid => {
                    await createRECManifest(shippingid, this.myStr);
                    let useriptracking = new UserIPTracking();
                    let userTrackingData = useriptracking.setMeta('REC Approved', shippingid)
                    .setRouteUrl('/EditActionByOpration')
                    .createObject();  
                    sendIPTrackingData(userTrackingData);
                  });
                }
                this.$alertify.success(ele.ReturnMessage)
                this.$router.push({ path: '/ActionByFinanceForcefullyLostBulk' });
              }, 500);
            }

            else {
              this.$alertify.error(ele.ReturnMessage)
            }
          });

          })
      }//else
    }

  },
};



// WEBPACK FOOTER //
// ./src/views/components/EditActionByFinance/EditActionByFinance.component.js